/**
 * Created by Ning Jiang on 10/12/2018.
 */

import {NineSliceButton} from "@nolimitcity/slot-game/bin/core/component/NineSliceButton";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {TimelineLite, TweenLite} from "gsap";
import {DirtyWildsTextStyles} from "../../config/DirtyWildsTextStyles";
import {DirtyWildGameModuleConfig} from "../DirtyWildGameModuleConfig";
import {DirtyWildsGameAssets} from "../DirtyWildsGameAssets";
import {DirtyWildsGameConfig} from "../DirtyWildsGameConfig";
import {DirtyWildsSoundConfig} from "../DirtyWildsSoundConfig";
import {DirtyWildsStrings} from "../DirtyWildsStrings";
import {DirtyWildsBitMap} from "../display/DirtyWildsBitMap";
import {DirtyWildGameMode} from "../features/DirtyWildsRespinZeroBetController";
import {DirtyWildsParsedGameData} from "../server/data/DirtyWildsParsedGameData";
import {DirtyWildsStateReelSymbol} from "../symbols/DirtyWildsStateReelSymbol";

export class DirtyWildsFreespinOutroView extends ScreenView {
    private _gameWidth:number;
    private _isPortrait:boolean;
    private _youWonStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "66px",
        fontWeight : FontWeight.BOLD,
        fill : [
            "#fffff8",
            "#ffec54",
            "#e3b647"
        ],
        fillGradientStops : [
            0.3,
            0.57,
            1
        ],
        dropShadowColor : "#2b003f",
        dropShadow : true,
        dropShadowAngle : 20,
        dropShadowDistance : 6,
        stroke : "#99FFCC",
        strokeThickness : 1,
    };

    private _spinsPlayedStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "54px",
        fontWeight : FontWeight.BOLD,
        fill : ["#FFFFFF"],
        fillGradientStops : [
            0.3,
            0.57,
            1
        ],
        dropShadowColor : "#2b003f",
        dropShadow : true,
        dropShadowAngle : 20,
        dropShadowDistance : 6,
        stroke : "#99FFCC",
        strokeThickness : 1,
    };

    private _container:PIXI.Container;
    private _darkOverlay:PIXI.Graphics;
    private _youWinText:PIXI.Text;
    private _winAmonut:DirtyWildsBitMap;
    private _spinsPlayed:PIXI.Text;
    private _playSoundCallback:() => void;
    private _outroSpine:PIXI.spine.Spine;

    constructor(config:IScreenViewConfig, autoClose:boolean = false) {
        super(config, true);
    }

    protected createGameGraphics():PIXI.DisplayObject {
        const container:PIXI.Container = new PIXI.Container();

        this._darkOverlay = new PIXI.Graphics;
        container.addChild(this._darkOverlay);

        this._outroSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(DirtyWildsGameAssets.MYSTERY_SPINE));
        this._outroSpine.position.set(-20, -30);
        container.addChild(this._outroSpine);

        this._youWinText = new PIXI.Text(` ${Translation.translate(DirtyWildsStrings.FS_YOU_WON_TEXT)} `, this._youWonStyle);
        this._youWinText.anchor.set(0.5);
        this._youWinText.position.set(0, -168);
        container.addChild(this._youWinText);

        this._winAmonut = new DirtyWildsBitMap("0", DirtyWildsTextStyles.WIN_DISPLAY_NUMBERS);
        this._winAmonut.anchor = new PIXI.Point(0.5, 0.5);
        this._winAmonut.maxWidth = DirtyWildsGameConfig.instance.REEL_AREA_WIDTH * 0.9;
        this._winAmonut.position.set(-28, -33);
        container.addChild(this._winAmonut);

        this._spinsPlayed = new PIXI.Text("", this._spinsPlayedStyle);
        this._spinsPlayed.anchor.set(0.5);
        container.addChild(this._spinsPlayed);

        this.reset();

        this._container = container;
        return container;
    }

    protected createButton():NineSliceButton {
        const button:NineSliceButton = super.createButton();
        button.visible = false;
        return button;
    }

    protected onResizeGameGraphics(data:IResizeData):void {
        this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
        this._isPortrait = data.orientation === Orientation.PORTRAIT;
        this._gameWidth = data.width / this._layer.scale.x;
        this.updateWinAmountFont();
        this._darkOverlay.clear();
        this._darkOverlay.beginFill(0x000000, 0.8);
        this._darkOverlay.drawRect(-this._screenWidth / 2, -this._screenHeight / 2, this._screenWidth, this._screenHeight);
    }

    protected startPresentation(data?:DirtyWildsParsedGameData, onShowComplete?:() => void):void {
        if (!data) {
            return;
        }

        this._autoCloseTimer.visible = false;
        const timeline:TimelineLite = new TimelineLite({
            onComplete : () => {
                this._onButtonClickCallback();
            }
        });
        const fs:number = 0.033;
        const symbol:DirtyWildsStateReelSymbol = <DirtyWildsStateReelSymbol>Reels.getSymbol(2, 1);

        // #231
        const totalWinBelowStake: boolean = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.totalWin <= data.playedBetValue));

        symbol.speedUpCoolDown = true;
        timeline.add(TweenLite.fromTo(this._container, 0.1, {alpha : 0}, {alpha : 1}));
        timeline.add(() => this._outroSpine.state.setAnimation(0, "endPresentation", false));
        timeline.add([
            () => DirtyWildGameModuleConfig.soundPlayer.switchToMainMusic(true),
            () => {
                // #231
                if (!totalWinBelowStake) {
                    SlotGame.sound.playEffect(DirtyWildsSoundConfig.FEATURE_ENDS);
                }
            },
            symbol!.changeState({
                state : DirtyWildsGameConfig.instance.SYMBOL_STATES.coolDown,
                fadeInDuration : 0
            }),
        ]);
        if(data!.totalWin > 0) {
            this._winAmonut.text = data!.totalWin.toFixed(2);
            this.updateWinAmountFont();
            timeline.add(TweenLite.fromTo(this._winAmonut, 0.2,
                {alpha : 0},
                {alpha : 1, onStart : () => this._winAmonut.visible = true}), 0);
            timeline.add(
                new TimelineLite().fromTo(this._winAmonut.scale, 5 * fs, {x : 0, y : 0}, {x : 0.2, y : 0.2})
                    .to(this._winAmonut.scale, 5 * fs, {x : 1, y : 1})
                , 0);

            timeline.add(TweenLite.fromTo(this._youWinText, 0.2,
                {alpha : 0},
                {alpha : 1, onStart : () => this._youWinText.visible = true}), 0.2);
            timeline.add(() => this.playSound());

            this._spinsPlayed.position.set(0, 74);
        } else {
            timeline.add(() => this.playSound(), 0);
            this._spinsPlayed.position.set(0, -25);
        }
        this._spinsPlayed.text = ` ${Translation.translate(DirtyWildsStrings.FS_SPINS_PLAYED)} ${data.numberOfRespinPlayed!.toString()} `;
        timeline.add(TweenLite.fromTo(this._spinsPlayed, 0.2,
            {alpha : 0},
            {alpha : 1, onStart : () => this._spinsPlayed.visible = true}), 0.2);
        timeline.add([
            DirtyWildGameModuleConfig.topBarView.setTopBar(0, 1, 0),
            DirtyWildGameModuleConfig.effectManager.getChangeBackgroundAnimation(DirtyWildGameMode.NORMAL, 1.5)
        ]);
        timeline.add([
            () => SlotGame.sound.fadeAmbience(1, 2000)
        ]);
        timeline.add(TweenLite.fromTo(this._container, 2, {alpha : 1}, {alpha : 0}));
    }

    private updateWinAmountFont():void {
        this._winAmonut.updatePosition(this._gameWidth * 0.8, this._isPortrait ? 150 : 180);
    }

    protected stopPresentation(closeCallback?:() => void):void {
        this.reset();
        this._button.visible = false;
        this._autoCloseTimer.visible = false;
        super.stopPresentation(closeCallback);
    }

    private reset():void {
        this._youWinText.visible = false;
        this._winAmonut.visible = false;
        this._spinsPlayed.visible = false;
    }

    public getPlaySoundCallback(playSoundCallback:() => void):void {
        this._playSoundCallback = playSoundCallback;
    }

    private playSound():void {
        if(this._playSoundCallback) {
            this._playSoundCallback();
        }
    }
}